import EnumService from '../EnumService'

export default class EscolaridadeEnumService extends EnumService{

    constructor(){
        super('enumEscolaridade');
    }
  
  }